import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalLayoutComponent } from './modal-layout.component';

@NgModule({
  declarations: [ModalLayoutComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  exports: [ModalLayoutComponent, MatButtonModule],
})
export class ModalLayoutModule {}
